import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const LiveViewerGraph = ({ data }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'ライブ視聴者数推移',
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            return `視聴者数: ${context.parsed.y}人`;
          }
        }
      }
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: '時間'
        },
        ticks: {
          maxTicksLimit: 15, // ラベルの数を制限
        }
      },
      y: {
        display: true,
        title: {
          display: true,
          text: '視聴者数（人）'
        },
        beginAtZero: true,
      },
    },
    elements: {
      point: {
        radius: 1,
      }
    },
    interaction: {
      intersect: false,
      mode: 'index',
    }
  };

  return <Line data={data} options={options} />;
};

export default LiveViewerGraph;